import React, { useRef, useState } from 'react'
import { usePermissionCheck } from '../../hooks/usePermissionCheck';
import { UserOperationTypes } from '../../common/types/AuthorizationProps';
import { buttonTexts } from '../../constants/texts/buttonTexts';
import PageTitle from '../components/PageTitle';
import { pageTitleTexts } from '../../constants/texts/pageTitleTexts';
import { Button } from '../components/Elements';
import { exportExcelHelper } from '../../common/helpers/exportExcelHelper';
import Filters from '../components/OrderInstallmentsReportTable/Filters';
import OrderInstallmentsReportTable from '../components/OrderInstallmentsReportTable/OrderInstallmentsReportTable';
import { useSelector } from 'react-redux';
import useAdminCheck from '../../hooks/useAdminCheck';

const OrderInstallmentsReport = () => {
    useAdminCheck();
    const [filtersIsOpen, setFiltersIsOpen] = useState(true);
    const [headCells, setHeadCells] = useState([]);
    const [excelLoading, setExcelLoading] = useState(false);
    const [isDetail, setIsDetail] = useState<boolean>(false);
    const [totalAmountCurrency, setTotalAmountCurrency] = useState<number>(0);

    const formFilterRef = useRef<HTMLDivElement | null>(null);
    const tableSelectedRows = useRef<any>();

    const { orderInstallmentsReport } = useSelector((state: any) => state.orderInstallmentsReport);
    const { orderInstallmentsReport: orderInstallmentsReportByVp } = useSelector((state: any) => state.orderInstallmentsReportPerVp);
    const exportToExcelClick = async () => {

        setExcelLoading(true);
        try {
            const tableData = isDetail ? orderInstallmentsReport : orderInstallmentsReportByVp;
            exportExcelHelper(tableData, "id", tableSelectedRows, headCells, "Geri_Odeme_Raporlari");
        } catch (error) {

        } finally {
            setExcelLoading(false);
        }
    }

    const handleHeadCells = (values: any) => {
        setHeadCells(values);
    }

    return (
        <div className="w-full">
            <PageTitle title={pageTitleTexts.orderInstallmentsReport} />

            <div className="px-4 pt-2 flex flex-row items-center justify-between space-y-2">
                <div className="flex flex-row items-center">
                    <img src={"/icons/islem-raporu-dark.svg"} className="h-6 w-6 black" />
                    <span className="text-lg font-bold leading-7 text-contrast-90 sm:truncate ml-2">
                        Geri Ödeme Raporları
                    </span>
                </div>

                <div className=" flex flex-row justify-end items-center px-2">
                    <Button
                        size="xs"
                        hover="gray"
                        color="gray"
                        callback={() => setFiltersIsOpen(!filtersIsOpen)}
                    >
                        <span className="mr-3">{buttonTexts.filterOpen}</span>
                        <img src="/icons/filter.svg" alt="filter" />
                    </Button>
                </div>
            </div>

            <Filters ref={formFilterRef} isOpen={filtersIsOpen} setFiltersIsOpen={setFiltersIsOpen} setIsDetail={setIsDetail} setTotalAmountCurrency={setTotalAmountCurrency}/>
            <div className="mr-4 flex justify-end">
                <Button
                    color="primary"
                    hover="primary"
                    size="xs"
                    callback={() => exportToExcelClick()}
                    loading={excelLoading}
                    disabled={excelLoading}
                >
                    <img src="/icons/download.svg" alt="pushToExcel" />
                    <span className='ml-3'>{buttonTexts.exportToExcel}</span>
                </Button>
            </div>
            <OrderInstallmentsReportTable formFilterRef={formFilterRef} getHeadCells={handleHeadCells} tableSelectedRows={tableSelectedRows} isDetail={isDetail} totalAmountCurrency={totalAmountCurrency}/>
        </div>
    )
}

export default OrderInstallmentsReport